import EntertainerShell from './EntertainerShell';

type Props = {
	status: 'confirmed' | 'not_found' | 'error';
};

const copy = {
	confirmed: {
		title: 'Your booking is confirmed',
		message: 'Thank you. The Goodwill Projects team has received your confirmation.',
	},
	not_found: {
		title: 'Booking not found',
		message: 'This confirmation link is not valid. Please contact the Goodwill Projects office for help.',
	},
	error: {
		title: 'We could not confirm this booking',
		message: 'Please try again. If the problem continues, contact the Goodwill Projects office.',
	},
};

export default function EntertainerBookingConfirmation({ status }: Props) {
	const content = copy[status] ?? copy.error;
	return (
		<EntertainerShell compact>
			<section className={`entertainer-result ${status}`} aria-live="polite">
				<div className="entertainer-result-mark" aria-hidden="true">
					<span className="material-symbols-outlined">{status === 'confirmed' ? 'task_alt' : 'error'}</span>
				</div>
				<h1>{content.title}</h1>
				<p>{content.message}</p>
			</section>
		</EntertainerShell>
	);
}
